import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import common from 'src/styles/common.module.scss'
import styles from '../styles.module.scss'

export const TextHeaderFr = () => {
    const isDesktop = useMediaQuery('(min-width: 768px)')

    return (
        <HighlightedText
            text="RÉCLAMEZ VOTRE BONUS"
            highlights={[
                { word: 'RÉCLAMEZ' },
                { word: 'VOTRE' },
                { word: 'BONUS' },
            ]}
            breakAfterWords={isDesktop ? [] : ['RÉCLAMEZ']}
            className={common.text_header}
        />
    )
}

export const TextLandFr = () => {
    return (
        <HighlightedText
            text="bonus de 325% + 400 TOURS GRATUITS"
            highlights={[{ word: '325%' }, { word: '+ 400' }]}
            breakAfterWords={['325%']}
            className={styles.text_content}
        />
    )
}
